import React from 'react';
import { ReleasePage } from './ReleasePage';


export const ESignReleaseVersion = () => {

    return (

        <ReleasePage
            title="eSign - Release Versions"
            jsonUrl="/releases_esign.json"
            mainReleaseType={["Long Term Support", "Release", "Long Term Stable"]}
            subReleaseType="Hotfix"
        />

    )
}
export default ESignReleaseVersion;